<template>
    <div class="form-group">
        <label for="recinto">{{ label }}</label>
        <multiselect
            :id="id"
            v-model="internalValue"
            :placeholder="label"
            :options="options.map(option => option.id)"
            :custom-label="(id) => options.find(option => option.id === id).email"
            :multiple="multiple"
            @input="onInput"
        />
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        id: {
            type: String,
            defaul: 'multiselect-id'
        },
        value: {
            type: Array,
            default: () => []
        },
        options: {
            type: Array,
            required: true
        },
        rules: {
            type: String,
            default: ''
        },
        multiple: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            internalValue: this.value
        }
    },
    watch: {
        value(newVal) {
            this.internalValue = newVal;
        }
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
        }
    }
}
</script>

<style scoped>
    .multiselect {
        z-index: 9 !important;
    }
</style>